import React, { useState } from 'react';
import { useAppContext } from '../context/AppContext';
import { Field, FieldDescription, FieldGroup, FieldLabel, FieldLegend, FieldSet } from '../components/ui/Form';
import { Input } from '../components/ui/Input';

const LoginPage = ({ onSwitchToRegister }) => {
  const { login } = useAppContext();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md">
      <form onSubmit={handleLogin}>
        <FieldGroup>
          <FieldSet>
            <FieldLegend>Welcome back to LuminAI</FieldLegend>
            <FieldDescription>Sign in to continue</FieldDescription>
          </FieldSet>
          <FieldSet>
            <Field>
              <FieldLabel htmlFor="email">Email Address</FieldLabel>
              <Input id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)} />
            </Field>
            <Field>
              <FieldLabel htmlFor="password">Password</FieldLabel>
              <Input id="password" type="password" placeholder="••••••••" required value={password} onChange={e => setPassword(e.target.value)} />
            </Field>
          </FieldSet>
          {error && <p className="text-sm text-red-500 text-center">{error}</p>}
          <button type="submit" disabled={loading} className="w-full h-10 inline-flex items-center justify-center rounded-md bg-blue-600 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50">
            {loading ? 'Signing In...' : 'Sign In'}
          </button>

      
          {/* <p className="text-center text-sm text-gray-500">
            Don't have an account?{' '}
            <button type="button" onClick={onSwitchToRegister} className="font-semibold text-blue-500 hover:underline">Create One</button>
          </p> */}
      
     
        </FieldGroup>
      </form>
    </div>
  );
};

export default LoginPage;